import { Box, Button, Modal, Switch, TextField } from '@mui/material'
import React, { useState } from 'react'
import moment from 'moment'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
  maxHeight: '90vh',
  overflow: 'auto',
}

const date = new Date()

const upcomingDates = [
  new Date().setDate(date.getDate() + 1),
  new Date().setDate(date.getDate() + 2),
  new Date().setDate(date.getDate() + 3),
  new Date().setDate(date.getDate() + 4),
  new Date().setDate(date.getDate() + 5),
  new Date().setDate(date.getDate() + 6),
  new Date().setDate(date.getDate() + 7),
]

const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

const availableDays = [
  {
    day:
      weekDays[new Date(new Date().setDate(date.getDate() + 1)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[0])).format('YYYY-MM-DD'),
  },
  {
    day: weekDays[new Date(new Date().setDate(date.getDate() + 2)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[1])).format('YYYY-MM-DD'),
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 1)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[2])).format('YYYY-MM-DD'),
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 2)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[3])).format('YYYY-MM-DD'),
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 3)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[4])).format('YYYY-MM-DD'),
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 4)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[5])).format('YYYY-MM-DD'),
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 5)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
    date: moment(new Date(upcomingDates[6])).format('YYYY-MM-DD'),
  },
]

const AdjustComingHoursModal = ({
  handleAdjustComingHoursModal,
  modalOpen,
  manageVacationTime,
  adjustUpcomingHour,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [checked, setChecked] = React.useState(
    new Array(weekDays.length).fill(false),
  )
  const [upcomingHours, setUpcomingHours] = useState([...availableDays])

  const [addBreak, setAddBreak] = useState(
    new Array(weekDays.length).fill(false),
  )

  const handleChange = (event, position) => {
    setUpcomingHours((prev) =>
      prev.map((item, index) => {
        if (position === index) {
          return { ...item, is_working: !item?.is_working }
        } else return { ...item }
      }),
    )
  }

  const handleAddBreak = (event, position) => {
    setUpcomingHours((prev) =>
      prev.map((item, index) => {
        if (position === index) {
          return { ...item, is_break: !item?.is_break }
        } else return { ...item }
      }),
    )
  }

  const handleTimeChange = (e, index) => {
    setUpcomingHours((prev) =>
      prev.map((item, ind) => {
        if (ind === index) {
          return { ...item, [e.target.name]: e.target.value }
        } else return { ...item }
      }),
    )
  }

  const handleAdjustUpcomingHours = async (e) => {
    e.preventDefault()
    let body = { user_id: user?.id, days: upcomingHours }
    let result = await saveOrUpdateDataById('adjust-coming-hours', body)
    if (result?.success === true) {
      Swal.fire({
        icon: 'success',
        title: 'Upcoming hours updated successfully!',
        timer: 2000,
        confirmButtonColor: '#2597F6',
      })
    }
    handleAdjustComingHoursModal(false)
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleAdjustComingHoursModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="ongoing-availability-modal-wrapper">
            <h3 className="fs-24 mb-4 fw-bold">Adjust Upcoming Hours</h3>
            <form onSubmit={handleAdjustUpcomingHours}>
              {upcomingHours.map((date, index) => {
                const day = weekDays[moment(date).day() - 1]
                return (
                  <div key={index}>
                    <div
                      className="day-section mt-3 px-2 d-flex justify-content-between align-items-center py-1"
                    >
                      <div className="text-left">
                        <p>{moment(date?.date).format('MMM DD, YYYY')}</p>
                        <p>{date?.day ? date?.day : 'Sunday'}</p>
                      </div>

                      <div className="py-1">
                        <Switch
                          checked={date?.is_working}
                          size={'small'}
                          key="index"
                          value={day?.start_time}
                          className="switch"
                          onChange={(e) => handleChange(e, index)}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>
                    </div>
                    {date?.is_working && (
                      <div>
                        <div className="set-time px-2 py-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="m-0 font-weight-bold">Hours</p>
                            <div>
                              <TextField
                                id="time"
                                type="time"
                                name="start_time"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                required={date?.is_working}
                                onChange={(e) => handleTimeChange(e, index)}
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <p className="m-0 font-weight-bold">To</p>
                            <div>
                              <TextField
                                onChange={(e) => handleTimeChange(e, index)}
                                id="time"
                                type="time"
                                value={date?.end_time}
                                name="end_time"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                required={date?.is_working}
                              />
                            </div>
                          </div>
                        </div>
                        {date?.is_break && (
                          <div className="set-time px-2 py-2">
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="m-0 font-weight-bold">BREAK</p>
                              <div>
                                <TextField
                                  onChange={(e) => handleTimeChange(e, index)}
                                  value={date?.break_start}
                                  id="time"
                                  type="time"
                                  required={date?.is_break}
                                  name="break_start"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2">
                              <p className="m-0 font-weight-bold">TO</p>
                              <div>
                                <TextField
                                  onChange={(e) => handleTimeChange(e, index)}
                                  id="time"
                                  type="time"
                                  value={date?.break_end}
                                  required={date?.is_break}
                                  name="break_end"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="m-0 break">
                          <h3
                            className="fs-12 mt-2 pointer"
                            style={date?.is_break ? { color: 'red' } : {}}
                            onClick={(e) => handleAddBreak(e, index)}
                          >
                            {date?.is_break ? 'REMOVE BREAK' : 'ADD BREAK'}
                          </h3>
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
              <Button
                fullWidth
                id="btn-primary-no-shadow"
                className="mt-3"
                type="submit"
              >
                Save
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default AdjustComingHoursModal
